import React, {useEffect, useRef, useState} from "react";
import {Button, Modal, Table, Tooltip, Tabs, message, Dropdown} from "antd";
import {DeleteOutlined, EditOutlined, BorderOutlined, RightOutlined, CarOutlined, DownloadOutlined, FolderOutlined, FolderFilled, CloseSquareFilled, EyeOutlined} from '@ant-design/icons';
import TrackerLocationModal from "../components/TrackerLocationModal";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import useInterval from "../hooks/useInterval";
import FusionService from "../services/fusion.service";
import TrackerService from "../services/tracker.service";
import {downloadTableAsCsv} from "../services/export-csv.service";
import {engine_broadcast} from "../classes/engine_broadcast";
import _ from "lodash";
const {confirm} = Modal;

const fusionListTab = "1"
const trackersStateTab = "2"
const trackerSupervisionTab = "3"
const GET_TRACKERS_STATE_LIST_FREQUENCY = 3000;
export default function TrackerFusionList() {
    const {t} = useTranslation();
    // eslint-disable-next-line
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState("1");
    const [trackersStatePageDisplayed, setTrackersStatePageDisplayed] = useState(false)
    const [availableFusions, setAvailableFusions] = useState([]);
    const [trackerStates, setTrackerStates] = useState([]);
    const [trackersSupervision, setTrackersSupervision] = useState([]);
    const history = useHistory();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [pingModal, setPingModal] = useState({visible: false, trackerId: null, trackerNum: null});
    const [errors, setErrors] = useState([]);
    const webSocket = useRef();

    const showModal = () => {
        setIsModalVisible(true);
    };

    const changeTab = (activeKey) => {
        setActiveTab(activeKey);
        switch (activeKey) {
            case fusionListTab:
                closeSocket();
                loadFusionList();
                setTrackersStatePageDisplayed(false);
                break;
            case trackersStateTab:
                closeSocket();
                setTrackersStatePageDisplayed(true);
                break;
            case trackerSupervisionTab:
                connectSocket();
                setTrackersStatePageDisplayed(false);
                break;
            default:
                // do nothing
        }
    };

    const getTrackersStateList = async () => {
        return TrackerService.getTrackersState()
            .then((r) => {
                if (r && r.data) {
                    setTrackerStates(r.data);
                    setLoading(false);
                }
            });
    }

    const loadFusionList = async () => {
        return FusionService.listAll()
            .then(list => {
                const trackersUses = {}
                function takeIntoAccountTrackers(fusionId, trackerId) {
                    if (!trackerId) {
                        return;
                    }
                    trackersUses[trackerId] = trackersUses[trackerId] || [];
                    trackersUses[trackerId].push(fusionId);
                }
                const fusions = list.map(fusion => {
                        takeIntoAccountTrackers(fusion.fusionId, fusion.trackers[0]);
                        takeIntoAccountTrackers(fusion.fusionId, fusion.trackers[1]);
                        takeIntoAccountTrackers(fusion.fusionId, fusion.trackers[2]);
                        takeIntoAccountTrackers(fusion.fusionId, fusion.trackers[3]);
                        takeIntoAccountTrackers(fusion.fusionId, fusion.trackers[4]);
                        return {
                            id: fusion.id,
                            fusionId: fusion.fusionId,
                            tracker1: fusion.trackers[0] ? fusion.trackers[0] : '-',
                            tracker2: fusion.trackers[1] ? fusion.trackers[1] : '-',
                            tracker3: fusion.trackers[2] ? fusion.trackers[2] : '-',
                            tracker4: fusion.trackers[3] ? fusion.trackers[3] : '-',
                            tracker5: fusion.trackers[4] ? fusion.trackers[4] : '-',
                        }
                    })
                setAvailableFusions(fusions);
                setLoading(false);
                const errors = [];
                Object.keys(trackersUses)
                    .map(key => ({capteur: key, fusions: trackersUses[key]}))
                    .filter(item => item.fusions.length > 1)
                    .forEach(item => errors.push(t('TrackerFusion.error.tracker_uses_in_several_fusions', {capteur: item.capteur, nbFusions: item.fusions.length, fusionsList: item.fusions.join(', ')})))
                setErrors(errors);
            }).catch(() => {
                message.error(t('common.error'))
            });
    }

    const deleteFusion = async (id) => {
        return FusionService.delOne(id)
            .then(() => loadFusionList())
            .catch(() => message.error(t('common.error')));
    }

    // handler --------------------------------------------------------
    const create = () => {
        history.push('/fusion/');
    }

    const exportCsv = () => {
        downloadTableAsCsv('merge-trackers-list', [0,1,2,3,4,5]);
    }

    const importCsv = () => {
        history.push('/fusion-import/');
    }

    const edit = (e, id) => {
        history.push('/fusion/' + id);
    }

    const setTrackerLive = (id) => {
        TrackerService.setTrackerState({id: id, state:"live"}).then();
    }

    const setTrackerStandby = (id) => {
        TrackerService.setTrackerState({id: id, state:"standby"}).then();
    }

    const setTrackerShip = (id) => {
        TrackerService.setTrackerState({id: id, state:"ship"}).then();
    }

    const setTrackerDownloadIMU = (id) => {
        TrackerService.setTrackerState({id: id, state:"download_imu"}).then();
    }
    const setTrackerStopIMU = (id) => {
        TrackerService.setTrackerState({id: id, state:"stop_imu"}).then();
    }
    const setTrackerCleanupIMU = (id) => {
        TrackerService.setTrackerState({id: id, state:"cleanup_imu"}).then();
    }

    const setAllTrackersLive = () => {
        TrackerService.setAllTrackersState({state:"live"}).then();
    }

    const setAllTrackersStandby = () => {
        TrackerService.setAllTrackersState({state:"standby"}).then();
    }

    const setAllTrackersShip = () => {
        setIsModalVisible(false);
        TrackerService.setAllTrackersState({state:"ship"}).then();
    }

    const setLive = (fusionId) => {
        FusionService.setFusionState({fusionId: fusionId, state:true}).then();
    }

    const setStandby = (fusionId) => {
        FusionService.setFusionState({fusionId: fusionId, state:false}).then();
    }

    const del = async (e, id) => {
        confirm({
            title: t('Confirmer la suppression ?'),
            content: t('La suppression est définitive'),
            onOk: () => deleteFusion(id),
            onCancel : () => {},
        });
    }

    // engine broadcast reciever --------------------------------------
    const wsReceive = (self, res) => {
        let cmd = res[0];
        let data = res[1];
        if (_.isEmpty(self)) {
            return;
        }
        switch (cmd) {
            case "all_trackers_supervision":
                setTrackersSupervision(data.sort((a, b) => {
                    if (a.req_state === 'ON' && b.req_state !== 'ON') {
                        return -1;
                    } else if (a.req_state !== 'ON' && b.req_state === 'ON') {
                        return 1;
                    } else {
                        return a.id - b.id;
                    }
                }));
                break;
            // ========= DEFAULT =========
            default:
                break;
        }
    }

    const connectSocket = () => {
        webSocket.current = new engine_broadcast();
        webSocket.current.set_callback(wsReceive);
        webSocket.current.connect();
        webSocket.current.send_cmd('all_trackers_supervision', 'start');
        window.addEventListener('beforeunload', closeSocket);
    }

    const closeSocket = () => {
        if (webSocket.current) {
            webSocket.current.send_cmd('all_trackers_supervision', 'stop');
            webSocket.current.close();
            window.removeEventListener('beforeunload', closeSocket);
        }
    }

    useInterval( () => {
        if (trackersStatePageDisplayed) {
            getTrackersStateList();
        }
    }, GET_TRACKERS_STATE_LIST_FREQUENCY);

    // useEffect ------------------------------------------------------
    useEffect(() => {
        setLoading(true);
        loadFusionList();
        return () => {
            closeSocket();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // column definition ----------------------------------------------
    const columnsTrackersSupervision = [
        {
            title: t('TrackerSupervision.id'),
            dataIndex: 'id',
            width: '5%',
            sorter: (a, b) => a.id - b.id
        },
        {
            title: t('TrackerSupervision.chrg'),
            dataIndex: 'isInCharge',
            width: '5%',
            sorter: (a, b) => a.isInCharge.localeCompare(b.isInCharge)
        },
        {
            title: t('TrackerSupervision.ds'),
            dataIndex: 'debit_send',
            width: '5%'
        },
        {
            title: t('TrackerSupervision.dr'),
            dataIndex: 'debit_receive',
            width: '5%'
        },
        {
            title: t('TrackerSupervision.lt'),
            dataIndex: 'last_time',
            width: '5%'
        },
        {
            title: t('TrackerSupervision.gps'),
            dataIndex: 'nb_gps',
            width: '5%'
        },
        {
            title: t('TrackerSupervision.dw'),
            dataIndex: 'nb_dw',
            width: '5%'
        },
        {
            title: t('TrackerSupervision.ts_dw'),
            dataIndex: 'nb_ts_dw',
            width: '5%'
        },
        {
            title: t('TrackerSupervision.sat'),
            dataIndex: 'num_sv',
            width: '5%'
        },
        {
            title: t('TrackerSupervision.mod'),
            dataIndex: 'mode',
            width: '5%',
            sorter: (a, b) => a.mode.localeCompare(b.mode)
        },
        {
            title: t('TrackerSupervision.bat'),
            dataIndex: 'bat',
            width: '5%'
        },
        {
            title: t('TrackerSupervision.csq'),
            dataIndex: 'qual_3g',
            width: '5%'
        },
        {
            title: t('TrackerSupervision.ntk'),
            dataIndex: 'mccMnc',
            width: '5%',
            sorter: (a, b) => a.mccMnc.localeCompare(b.mccMnc)
        },
        {
            title: t('TrackerSupervision.type'),
            dataIndex: 'ntwkTechnology',
            width: '5%'
        },
        {
            title: t('TrackerSupervision.percent_dw'),
            dataIndex: 'invalid_dw_ratio_1',
            width: '5%'
        },
        {
            title: t('TrackerSupervision.delta_dw'),
            dataIndex: 'invalid_dw_maxDelayMean_1',
            width: '5%'
        },
        {
            title: t('TrackerSupervision.hr'),
            dataIndex: 'hr_value',
            width: '5%'
        },
        {
            title: t('TrackerSupervision.pwr'),
            dataIndex: 'power_value',
            width: '5%'
        },
    ]

    const columnsTrackersState = [
        {
            title: t('TrackerFusion.fusionId'),
            dataIndex: 'id',
            hidden: true
        },
        {
            title: t('TrackerState.number'),
            dataIndex: 'num_capt',
            sorter: (a, b) => a.num_capt - b.num_capt,
        },
        {
            title: t('TrackerState.fw'),
            dataIndex: 'version_fw'
        },
        {
            title: t('TrackerState.iccid'),
            dataIndex: 'iccid'
        },
        {
            title: t('TrackerState.type'),
            dataIndex: 'type'
        },
        {
            title: t('TrackerState.lastMessage'),
            dataIndex: 'last_message_reception_time',
            sorter: (a, b) => new Date(a.last_message_reception_time) - new Date(b.last_message_reception_time)
        },
        {
            title: t('TrackerState.state'),
            dataIndex: 'state',
            render: (value) => (value) ? 'ON' : 'OFF',
            sorter: (a, b) => a.state - b.state
        },
        {
            title: t('TrackerState.stateNeed'),
            dataIndex: 'state_need',
            render: (value) => (value) ? 'ON' : 'OFF',
            sorter: (a, b) => a.state_need - b.state_need
        },
        {
            title: t('TrackerFusion.action'),
            dataIndex: 'action',
            key: 'action',
            className: 'col_action',
            render: (value, record) => {
                return <div className="imu_actions">
                    <span className="action imu_actions">
                        <Tooltip title={`Localiser le tracker ${record.num_capt}`}>
                            <Button onClick={() => 
                                {
                                    if (record.hardware)
                                    {
                                        setPingModal({visible: true, trackerId: record.hardware, trackerNum: record.num_capt});
                                    }
                                    else
                                    {
                                        message.error('An error occured while searching the tracker');
                                    }
                                }
                                } shape="circle" icon={<EyeOutlined/>}/>
                        </Tooltip>
                        <Tooltip title={`${t('TrackerState.live')}${record.num_capt}`}>
                            <Button onClick={() => setTrackerLive(record.id)} shape="circle" icon={<RightOutlined/>}/>
                        </Tooltip>
                        <Tooltip title={`${t('TrackerState.standby')}${record.num_capt}`}>
                            <Button onClick={() => setTrackerStandby(record.id)} shape="circle" icon={<BorderOutlined/>}/>
                        </Tooltip>
                        <Tooltip title={`${t('TrackerState.ship')}${record.num_capt}`}>
                            <Button onClick={() => setTrackerShip(record.id)} shape="circle" icon={<CarOutlined/>}/>
                        </Tooltip>
                    </span>

                </div>
            }
        },
        {
            title: 'IMU',
            dataIndex: 'action',
            key: 'action',
            className: 'col_action',
            render: (value, record) => {
                return <div className="imu_actions">
                    {
                        record.imu_connected &&
                        <span className="action imu_actions">
                            {
                                record.imu && record.imu_last === 0 &&
                                <Tooltip title={`Download IMU datas of ${record.num_capt}`}>
                                    <Button onClick={() => setTrackerDownloadIMU(record.id)} shape="circle" icon={<DownloadOutlined/>}/>
                                </Tooltip>
                            }
                            {
                                record.imu && record.imu_last > 0 &&
                                <div className="imu_progress">
                                    <span className="imu_percent">{(Math.floor(record.imu_current * 100 * 100 / record.imu_last) / 100) + '%'}</span>
                                    <Tooltip title={`Stop download IMU datas of ${record.num_capt}`}>
                                        <Button size="small" onClick={() => setTrackerStopIMU(record.id)} shape="circle" icon={<CloseSquareFilled/>}/>
                                    </Tooltip>
                                </div>
                            }
                            {
                                record.imu && record.imu_reseting !== "true" && 
                                <Tooltip title={`Cleanup IMU datas of ${record.num_capt}`}>
                                    <Button onClick={() => setTrackerCleanupIMU(record.id)} shape="circle" icon={<DeleteOutlined/>}/>
                                </Tooltip>
                            }
                            {
                                record.imu && record.imu_reseting === "true" && 
                                <div className="imu_progress">
                                    <Button size="small" onClick={() => setTrackerCleanupIMU(record.id)} shape="circle" icon={<DeleteOutlined/>}/>
                                    <span className="imu_percent">reseting</span>
                                </div>
                            }
                            {
                                record.imu && record.imu_hasfile === "true" &&
                                <>
                                    <Tooltip title={`Get csv IMM datas of ${record.num_capt}`}>
                                        <Button onClick={() => TrackerService.downloadImuCsv({trackers: "" + record.num_capt})} shape="circle" icon={<FolderOutlined/>}/>
                                    </Tooltip>
                                    <Tooltip title={`Get binary IMU datas of ${record.num_capt}`}>
                                        <Button onClick={() => TrackerService.downloadImuBin({trackers: "" + record.num_capt})} shape="circle" icon={<FolderFilled/>}/>
                                    </Tooltip>
                                </>
                            }
                        </span>
                }
                </div>
            }
        },
    ].filter(item => !item.hidden);

    const columns = [
        {
            title: t('TrackerFusion.fusionId'),
            dataIndex: 'fusionId',
            sorter: (a, b) => a.fusionId - b.fusionId,
        },
        {
            title: t('TrackerFusion.trackerId1'),
            dataIndex: 'tracker1'
        },
        {
            title: t('TrackerFusion.trackerId2'),
            dataIndex: 'tracker2'
        },
        {
            title: t('TrackerFusion.trackerId3'),
            dataIndex: 'tracker3'
        },
        {
            title: t('TrackerFusion.trackerId4'),
            dataIndex: 'tracker4'
        },
        {
            title: t('TrackerFusion.trackerId5'),
            dataIndex: 'tracker5'
        },
        {
            title: t('TrackerFusion.action'),
            dataIndex: 'action',
            key: 'action',
            className: 'col_action',
            render: (value, record) => {
                return <>
                    <span className="action">
                        <Tooltip title={`${t('utilisateur.live')}${record.fusionId}`}>
                            <Button onClick={() => setLive(record.fusionId)} shape="circle" icon={<RightOutlined/>}/>
                        </Tooltip>
                    </span>
                    <span className="action">
                        <Tooltip title={`${t('utilisateur.standby')}${record.fusionId}`}>
                            <Button onClick={() => setStandby(record.fusionId)} shape="circle" icon={<BorderOutlined/>}/>
                        </Tooltip>
                    </span>
                    <span className="action">
                        <Tooltip title={t('utilisateur.Modifier')}>
                            <Button onClick={(e) => edit(e, record.fusionId)} shape="circle" icon={<EditOutlined/>}/>
                        </Tooltip>
                    </span>
                    <span className="action">
                        <Tooltip title={t('utilisateur.supprimer')}>
                            <Button onClick={(e) => del(e, record.id)} shape="circle" icon={<DeleteOutlined/>}/>
                        </Tooltip>
                    </span>
                </>
            }
        },
    ]
    const handleMenuClick = ({ key }) => {
        console.log(key);
    switch (key) {
        case 'menu1':
            TrackerService.setAllTrackersState({state:"imu_download", trackers: "all"}).then();
            break;
        case 'menu2':
            TrackerService.setAllTrackersState({state:"imu_stop", trackers: "all"}).then();
            break;
        case 'menu3':
            TrackerService.setAllTrackersState({state:"imu_erase", trackers: "all"}).then();
            break;
        case 'menu4':
            TrackerService.downloadImuCsv({trackers: "all"}).then();
            break;
        case 'menu5':
            TrackerService.downloadImuBin({trackers: "all"}).then();
            break;
        default:
            message.info(`Action inconnue : ${key}`);
    }
    };
    const imuitems =
    [
        { key: 'menu1', label: 'Download All' },
        { key: 'menu2', label: 'Stop All' },
        { key: 'menu3', label: 'Erase All' },
        { key: 'menu4', label: 'Get Csv' },
        { key: 'menu5', label: 'Get Binary' },
    ];

    const tabItems = [
        {
            key: '1',
            label: t('TrackerFusion.title'),
            children: (
                <>
                    <div className="header" id="tracker_fusion">
                        <div className="sub_header_title">
                            <span className="subtitle">{t('TrackerFusion.subtitle')}</span>
                        </div>
                        <div className="sub_header_action">
                            <Button className="btn_add" onClick={create}>{t('common.add')}</Button>
                        </div>
                        <div className="sub_header_action">
                            <Button className="btn_export" onClick={importCsv}>{t('common.import')}</Button>
                        </div>
                        <div className="sub_header_action">
                            <Button className="btn_export" onClick={exportCsv}>{t('common.export')}</Button>
                        </div>
                    </div>
                    <ul className="notifiations">
                        {errors.map((error, index) => <li key={index} className="error">{error}</li>)}
                    </ul>
                    <div className="data_list">
                        <Table
                            id="merge-trackers-list"
                            columns={columns}
                            dataSource={availableFusions}
                            rowKey="fusionId"
                            loading={loading}
                            className="common_list tracker_fusion_list"
                            pagination={false}
                        />
                    </div>
                </>
            )
        },
        {
            key: '2',
            label: t('TrackerState.title'),
            children: (
                <>
                    <div className="header" id="tracker_state">
                        <div className="sub_header_title">
                            <span className="subtitle">{t('TrackerState.subtitle')}</span>
                        </div>
                        <div className="sub_header_action">
                            <Button className="btn_add" onClick={setAllTrackersLive} icon={<RightOutlined/>}>{t('TrackerState.allLive')}</Button>
                        </div>
                        <div className="sub_header_action">
                            <Button className="btn_export" onClick={setAllTrackersStandby} icon={<BorderOutlined/>}>{t('TrackerState.allStandby')}</Button>
                        </div>
                        <div className="sub_header_action">
                            <Button className="btn_export" onClick={showModal} icon={<CarOutlined/>}>{t('TrackerState.allShip')}</Button>
                        </div>
                        <div className="sub_header_action">
                            <Dropdown menu={{ items: imuitems, onClick: handleMenuClick }}>
                                <Button className="btn_imu">IMU</Button>
                            </Dropdown>
                        </div>
                    </div>

                    <div className="data_list">
                        <Table
                            id="trackers-status-list"
                            columns={columnsTrackersState}
                            dataSource={trackerStates}
                            rowKey="num_capt"
                            loading={loading}
                            className="common_list tracker_fusion_list"
                            rowClassName={(record) => {
                                if (record.state) {
                                    return 'live';
                                } else if (record.state_need) {
                                    return 'live_requested';
                                }
                                return '';
                            }}
                            pagination={false}
                        />
                    </div>
                </>
            )
        },
        {
            key: '3',
            label: t('TrackerSupervision.title'),
            children: (
                <>
                    <div className="header" id="tracker_supervision">
                        <div className="sub_header_title">
                            <span className="subtitle">{t('TrackerSupervision.subtitle')}</span>
                        </div>
                    </div>

                    <div className="data_list">
                        <Table
                            id="trackers-supervision-list"
                            columns={columnsTrackersSupervision}
                            dataSource={trackersSupervision}
                            rowKey="id"
                            loading={loading}
                            className="common_list tracker_fusion_list"
                            rowClassName={(record) => {
                                if (record.req_state === 'ON') {
                                    return 'live';
                                }
                                if (record.isInCharge === 'ON') {
                                    return 'in_charge';
                                }
                                return '';
                            }}
                            pagination={false}
                        />
                    </div>
                </>
            )
        }
    ];

    // render ---------------------------------------------------------
    return (
        <div className="private_page_wrapper">
            <Modal
                title={`${t('TrackerState.allShip')}`}
                open={isModalVisible}
                onOk={setAllTrackersShip}
                onCancel={() => setIsModalVisible(false)}>
                <span> {t('TrackerState.setShipModeMsgConfirm')}</span>
            </Modal>
            <TrackerLocationModal
                trackerId={pingModal.trackerId}
                trackerNum={pingModal.trackerNum}
                visible={pingModal.visible}
                onClose={() => setPingModal({visible: false, trackerId: null, trackerNum: null})}
            />
            <div className="merge_page_wrapper">
                <Tabs defaultActiveKey="1" activeKey={activeTab} onChange={changeTab} items={tabItems} />
            </div>
        </div>
    )

}